export default {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  TENANT_ADMIN_WRITE: 'TENANT_ADMIN_WRITE',
  SKIDATA_ADMIN_READ: 'SKIDATA_ADMIN_READ',
  SKIDATA_ADMIN_WRITE: 'SKIDATA_ADMIN_WRITE',
  SKIDATA_ADMIN_REPORT: 'SKIDATA_ADMIN_REPORT',
  SKIDATA_SYNC_PRICES: 'SKIDATA_SYNC_PRICES',
  BLS_ADMIN_READ: 'BLS_ADMIN_READ',
  BLS_ADMIN_REPORT: 'BLS_ADMIN_REPORT',
  MGB_ADMIN_REPORT: 'MGB_ADMIN_REPORT',
  MGB_ADMIN_READ: 'MGB_ADMIN_READ',
  MGB_ADMIN_WRITE: 'MGB_ADMIN_WRITE',
};



// WEBPACK FOOTER //
// ./src/auth/tenantRoles.js